import React from 'react';
import { Button, Form, Input, Icon, TextArea, Segment, Grid, Loader, Header, Divider, Message } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';
import { Redirect, Link } from 'react-router-dom';


import moment from 'moment';

export default class CreateNewPoll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPollPreview: false,
            showPollForm: true,
            types: [],
            selectedOrgUnits: [],
            orgUnitsOptions: [],
            startDate: new Date(),
            endDate: new Date(),
            resultDate: new Date(),
            nameErr: false,
            startDateErr: false,
            showPollList: false

        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.fetchPollType = this.fetchPollType.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.createPoll = this.createPoll.bind(this);
        this.fetchOrganizationalUnits = this.fetchOrganizationalUnits.bind(this);
    }


    componentDidMount() {
        this.fetchPollType();
        this.fetchOrganizationalUnits();
    }


    fetchPollType() {
        axios.get('/questionnaire/get-types/')
            .then(res => {
                const types = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ types });
            })
            .catch(err => {
                console.log('Failed to fetch poll types.');
            });
    }

    fetchOrganizationalUnits() {
        axios.get('/graduation-documents/faculties')
            .then(res => {
                const orgUnitsOptions = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ orgUnitsOptions });
            })
            .catch(err => {
                console.log('Failed to fetch poll orgUnitsOptions.');
            });
    }

    createPoll() {
        if (!this.state.name || !this.state.type || !this.state.startDate || !this.state.endDate || !this.state.resultDate) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.name) { this.setState({ nameErr: true }); } else { this.setState({ nameErr: false }); }
            if (!this.state.type) { this.setState({ typeErr: true }); } else { this.setState({ typeErr: false }); }
            if (!this.state.startDate) { this.setState({ startDateErr: true }); } else { this.setState({ startDateErr: false }); }
            if (!this.state.endDate) { this.setState({ endDateErr: true }); } else { this.setState({ endDateErr: false }); }
            if (!this.state.resultDate) { this.setState({ resultDateErr: true }); } else { this.setState({ resultDateErr: false }); }
        } else if (this.state.startDate >= this.state.endDate) {
            toast('Datum objave mora biti prije datuma isteka.');
            this.setState({ startDateErr: true, endDateErr: true });
        } else if (this.state.resultDate < this.state.endDate) {
            toast('Datum objave rezultata mora biti nakon datuma isteka.');
            this.setState({ resultDateErr: true, endDateErr: true });
        } else {
            this.setState({ loader: true });
            let obj = {
                questionnaire: {
                    name: this.state.name,
                    comment: this.state.comment,
                    questionnaireType: { id: this.state.type },
                    activationDate: this.state.startDate,
                    endDate: this.state.endDate,
                    statisticsActivationDate: this.state.resultDate
                },

                organizationalUnits: this.state.selectedOrgUnits

            };
            axios.post('questionnaire/create-connect/', { ...obj })
                .then(res => {
                    this.setState({
                        showPollForm: false,
                        pollId: res.data.id,
                        pollName: res.data.name,
                        pollType: res.data.questionnaireType.id
                    });
                }).then(res => {
                    let poll = {
                        pollId: this.state.pollId,
                        pollName: this.state.pollName,
                        pollType: this.state.pollType,
                    };
                    localStorage.setItem('poll', JSON.stringify(poll));
                    localStorage.setItem('edit', 'enable');
                    localStorage.setItem('delete', 'enable');
                }).then(res => {
                    this.setState({ showPollPreview: true, loader: false });
                    toast('Uspješno ste kreirali anketu.');
                })
                .catch(err => {
                    this.setState({ loader: false });
                    toast('Došlo je do greške. Kreiranje ankete nije uspješno izvršeno.');
                    console.log('Failed to create new poll.');
                });
        }
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        if (this.state.showPollPreview) return <Redirect push to={{ pathname: '/ankete/detalji' }} />;

        return (
            <div>

                <Grid columns={2} stackable centered>


                    <Grid.Column width={16} >

                        <Loader size="medium" active={this.state.loader} />


                        { this.state.showPollForm && <Segment.Group raised style={{ backgroundColor: 'white' }}>


                            <Segment clearing>
                                <Header as="h3">
                                 Nova anketa
                                </Header>
                            </Segment>
                            <Segment clearing>
                                <Form noValidate>

                                    <Grid columns={2} centered stackable >
                                        <Grid.Column width={8} stretched>
                                            <Form.Group widths="equal">
                                                <Form.Field required error={this.state.nameErr}>
                                                    <label>
                                                        {/* {<FormattedMessage id="common.title" />} */}
                                                    Naziv ankete
                                                    </label>
                                                    <FormattedMessage id="poll.placeholderPollName">
                                                        {(msg) => (<input
                                                            required
                                                            fluid
                                                            placeholder={msg}
                                                            control={Input}
                                                            value={this.state.name}
                                                            name="name"
                                                            onChange={(e) => this.setState({ name: e.target.value })}

                                                        />)}
                                                    </FormattedMessage>
                                                </Form.Field>

                                                <Form.Field>
                                                    <label>
                                                        {/* {<FormattedMessage id="common.notificationType" />} */}
                                                    Tip ankete
                                                    </label>
                                                    <Form.Dropdown
                                                        clearable
                                                        placeholder={<FormattedMessage id="poll.placeholderType" />}
                                                        value={this.state.type}
                                                        onChange={this.handleInputChange}
                                                        name="type"
                                                        options={this.state.types}
                                                        search
                                                        fluid
                                                        selection
                                                        required
                                                        error={this.state.typeErr}
                                                    />
                                                </Form.Field>

                                            </Form.Group>
                                            <Form.Field
                                                required
                                                control={DateTimePicker}
                                                label="Datum objave "
                                                format="D. M. YYYY."
                                                // defaultValue={new Date()}
                                                value={this.state.startDate}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'startDate')}
                                                style={{ borderWidth: '0px' }}
                                                error={this.state.startDateErr}
                                            />
                                            <Form.Field
                                                required
                                                control={DateTimePicker}
                                                label="Datum isteka "
                                                format="D. M. YYYY."
                                                // defaultValue={new Date()}
                                                value={this.state.endDate}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'endDate')}
                                                style={{ borderWidth: '0px' }}
                                                error={this.state.endDateErr}
                                            />
                                            <Form.Field
                                                required
                                                control={DateTimePicker}
                                                label="Datum objave rezultata"
                                                format="D. M. YYYY."
                                                defaultValue={new Date()}
                                                value={this.state.resultDate}
                                                time={false}
                                                onChange={this.handleDateChange.bind(null, 'resultDate')}
                                                style={{ borderWidth: '0px' }}
                                                error={this.state.resultDateErr}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={8} stretched>
                                            <Form.Field>
                                                <label>
                                                    {/* {<FormattedMessage id="common.notificationType" />} */}
                                                    Fakulteti
                                                </label>
                                                <Form.Dropdown
                                                    multiple
                                                    clearable
                                                    placeholder="Odaberite fakultete"
                                                    value={this.state.selectedOrgUnits}
                                                    onChange={this.handleInputChange}
                                                    name="selectedOrgUnits"
                                                    options={this.state.orgUnitsOptions}
                                                    search
                                                    fluid
                                                    selection
                                                />
                                            </Form.Field>
                                            <Form.Field >
                                                <label>
                                                    {/* {<FormattedMessage id="common.notification" />} */}
                                            Komentar
                                                </label>
                                                <FormattedMessage id="poll.placeholderComment">
                                                    {(msg) => (<textarea
                                                        required
                                                        fluid
                                                        placeholder={msg}
                                                        control={TextArea}
                                                        rows="8"
                                                        label="Komentar"
                                                        value={this.state.comment}
                                                        name="comment"
                                                        onChange={(e) => this.setState({ comment: e.target.value })}
                                                    />)}
                                                </FormattedMessage>
                                            </Form.Field>
                                            <Form.Group widths="equal">
                                                <Form.Field>

                                                    <Button primary color="blue" fluid disabled={this.state.loader} onClick={this.createPoll} floated="right">
                                                        <Icon name="add"></Icon>
                                                            Kreiraj anketu

                                                    </Button>

                                                </Form.Field>
                                                <Form.Field>
                                                    <Link to={{
                                                        pathname: '/ankete',
                                                        state: { activeIndex: 1 }

                                                    }}
                                                    >
                                                        <Button

                                                            basic
                                                            color="blue"
                                                            fluid
                                                            disabled={this.state.loader}
                                                            floated="left"
                                                        >

                                                Odustani

                                                        </Button>
                                                    </Link>
                                                </Form.Field>
                                            </Form.Group>
                                        </Grid.Column>
                                    </Grid>

                                </Form>
                            </Segment>

                            <ToastContainer hideProgressBar />
                        </Segment.Group>}
                    </Grid.Column>


                    <ToastContainer hideProgressBar />
                </Grid>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/CreatePoll/CreateNewPollFormw.js